import React from "react";
import InterventionMultipleChoice from "../shared/InterventionMultipleChoice";
import cx from "classnames";
import Timeout from "await-timeout";
import { COPY_STRINGS } from "Constants/translatedCopy";
import { getUserData } from "Services/API";
import doNotUseAccessibleStaticElementInteractions from "A11y/doNotUseAccessibleStaticElementInteractions";

const expireTimer = new Timeout();

const EXPIRE_TIMEOUT = 10000;

export default class PictureMultipleChoice extends InterventionMultipleChoice {
  constructor(props){
    super(props);
  }
  componentDidMount() {
    this.getOptionClasses = this.getOptionClasses.bind(this);
    this.selectOption = this.selectOption.bind(this);

    const startTimer = this.startTimer.bind(this);
    const { enableButtons } = this.props;

    if (this.props.introText) {
      this.props.speech.abortSpeech(() => {
        const descriptor = getRandomArrayElement(
          COPY_STRINGS.intervention_strings.vocabulary_with_picture.descriptor
        );
        const onIntroEnd = () => {
          this.speakQuestion(() => {
            if (enableButtons) {
              enableButtons();
            }
            startTimer();
          });
        };
        if(getUserData().bilingualMode) {
          this.props.speech.speakSequence({
            textToSpeak: [
              {textToSpeak: word, skipTranslation: true},
              {textToSpeak: ttsStrings.intro({descriptor})},
            ],
            onEnd: onIntroEnd,
          });
        } else {
          this.props.speech.speak({
            textToSpeak:`${word} ${ttsStrings.intro({descriptor})}`,
            onEnd: onIntroEnd,
          });
        }
      });
    } else {
      //When no introduction, try checking if we're reading questions
      this.speakQuestion(() => {
        if (enableButtons) {
          enableButtons();
        }
        startTimer();
      });
    }
  }

  componentWillUnmount() {
    expireTimer.clear();
  }

  startTimer() {
    const { options, correctAnswer, disableButtons, expire } = this.props;

    expireTimer.set(EXPIRE_TIMEOUT).then(() => {
      if (this.state.selected.length == 0) {
        if (disableButtons) {
          disableButtons();
        }

        this.setState(
          { highlighted: options.indexOf(correctAnswer[0]) },
          () => {
            if (expire) {
              expire();
            }
          }
        );
      }
    });
  }

  getOptionClasses(option, index) {
    return cx({
      option: true,
      selected: this.state.selected.includes(option),
      highlightedOption: this.state.highlighted === index,
      disabled: this.props.buttonsDisabled,
    });
  }

  getAccessibleOptionAttributes(option) {
    return {
      ...doNotUseAccessibleStaticElementInteractions({onClick: this.onOptionClick.bind(this, option)}),
      role: "radio",
      "aria-label": option,
      "aria-checked": this.state.selected.includes(option),
    }
  }

  onOptionClick(option){
    if(!this.props.buttonsDisabled) {
      this.selectOption(option);
    }
  }

  getOptions() {
    const optionsContainerClasses = cx({
      "multiple-options": true,
      flat: this.props.flat,
      keepTall: this.props.keepTall,
    });

    const accessibleOptionGroupAttributes = {
      role: "radiogroup",
      "aria-required": true,
      "aria-label": "options",
    }

    if (this.props.flat) {
      return (
        <div className={optionsContainerClasses} {...accessibleOptionGroupAttributes}>
          {this.props.options.map((option, index) => {
            return (
              <div key={option} className={this.getOptionClasses(option, index)} {...this.getAccessibleOptionAttributes(option)}>
                <img src={option} alt="" />
              </div>
            );
          })}
        </div>
      );
    } else {
      return (
        <div className={optionsContainerClasses} {...accessibleOptionGroupAttributes}>
          <ol className="list">
            {this.props.options.map((option, index) => {
              return (
                <li key={option}>
                  <span className={this.getOptionClasses(option, index)} {...this.getAccessibleOptionAttributes(option)}>
                    <img src={option} alt="" />
                  </span>
                </li>
              );
            })}
          </ol>
        </div>
      );
    }
  }
}
